import React, { useEffect } from "react";
import queryString from 'query-string';
import "./App.css";
import Visualiser from "./components/modals/Visualiser";
import useInitializeSession from "./services/hooks/useInitializeSession";
import { SessionProvider } from "./services/utils/SessionContext";
import Loader from "./components/Loader";

function App() {
  const {
    initializeSession,
    response: images,
    error,
    showModal,
    setShowModal,
    uniqueId: session_id,
    vendorUrl,
    product_id,
    loading,
  } = useInitializeSession();

  const sessionData = {
    images,
    error,
    showModal,
    setShowModal,
    session_id,
    vendorUrl,
    product_id,
  };
  useEffect(() => {
    const queryParams = queryString.parse(window.location.search);

    // Check if the environment variable IS_DEVELOPMENT is true
    const isDevelopment = `${process.env.REACT_APP_IS_DEVELOPMENT || 'false'}` === 'true';

    const productId = queryParams.product_id || '7218845122658';
    const vendorUrl = queryParams.shop_url || 'https://quickstart-a24bdcaf.myshopify.com';
    const reference = queryParams.ref || null;
    
    initializeSession(productId, vendorUrl, reference);
  }, []);
  useEffect(() => {
    window.parent.postMessage({ type: "loading", state: loading }, "*");
  }, [loading]);
  return (
    <SessionProvider value={sessionData}>
      <div>
        {/* <button
          className="text-xl font-bold py-4 px-6 bg-transparent border cursor-pointer border-[#3FDD78] rounded-xl text-[#3FDD78] w-max hover:shadow-sm"
          onClick={() => {
            // const productId = "";
            // const href = window.location.ancestorOrigins[0];
            const productId = "7062284238946";
            const href = "https://quickstart-a24bdcaf.myshopify.com/products/sofa3";
            initializeSession(productId, href);
          }}
        >
          Stage in room
        </button> */}
        {loading && <Loader title={"Loading Nestflow Visualizer..."} vendorColor={"#FA5961"} loadDuration={50}/>}
        <Visualiser
          showModal={showModal}
          setShowModal={setShowModal}
          images={images}
          vendorLogo={images?.vendor_logo}
        />
      </div>
    </SessionProvider>
  );
}

export default App;
